import clsx from 'clsx'

import classes from './Field.module.css'
import { FieldKeyEditable, FieldKeyStatic } from './FieldKey'
import { FieldTypeSelector } from './FieldTypeSelector'
import { useSchemaBuilderContext } from '../../SchemaBuilder/SchemaContext'
import { SchemaBuilderFieldProps } from '../../SchemaBuilder/types'

export function Field({
  schema,
  name,
  onChange,
  onEnter,
  onEsc,
  onNameChange,
  deprecatedNames,
  className,
  level,
}: SchemaBuilderFieldProps) {
  const { readOnly } = useSchemaBuilderContext()

  const handleTypeChange = onChange
    ? (type) => {
        const newValue: any = {
          default: undefined,
          type,
        }

        switch (type) {
          case 'object':
            newValue.properties = {
              ['']: {
                type: 'string',
              },
            }
            break
          case 'array':
            newValue.items = {
              type: 'string',
            }
            break
        }

        onChange(newValue)
      }
    : undefined

  return (
    <div className={clsx(classes.fieldWrapper, className)}>
      {level === 0 ? (
        <span className='text-gray-500'>schema:</span>
      ) : (
        <>
          {onNameChange && !readOnly ? (
            <>
              <FieldKeyEditable
                autoFocus={!name}
                value={name}
                onChange={onNameChange}
                onEnter={onEnter}
                onEsc={onEsc}
                deprecatedNames={deprecatedNames}
              />
              <span>:</span>
            </>
          ) : (
            <FieldKeyStatic>{name}:</FieldKeyStatic>
          )}
        </>
      )}
      {/* FIXME: strictNullCheck temporary fix */}
      {/* @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message */}
      <FieldTypeSelector type={schema?.type} onTypeChange={handleTypeChange} />
    </div>
  )
}
